<div class="row pt-5" *ngIf="modParameter">

    <div class="col-md-12 col-xl-4">
        <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 0"
            [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 0" (click)="switchTo(0)">
            Cantidades y<br>Contratos
        </button>
    </div>

    <div class="col-md-6 mt-2 col-xl-4 mt-xl-0">
        <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 1"
            [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 1" (click)="switchTo(1)">
            Fechas De<br>Inscripción
        </button>
    </div>
    <div class="col-md-12 mt-2 col-xl-4 mt-xl-0">
        <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 2"
            [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 2" (click)="switchTo(2)">
            Compañías<br>Incluidas
        </button>
    </div>

</div>

<div class="row pt-2 pb-2" *ngIf="modParameter">

    <div class="col-md-6 mt-2 col-xl-4 mt-xl-0">
        <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 3"
            [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 3" (click)="switchTo(3)">
            Contratos<br>Incluidos
        </button>
    </div>

</div>

<div class="p-3" *ngIf="contentLocation.savingParametersIndex == 0">

    <div class="row">

        <div class="col-md-3">

            <mat-form-field>

                <span matPrefix>$&nbsp;</span>

                <input matInput placeholder="Monto Mínimo de Inscripción:" type="number" min="0"
                    [(ngModel)]="modParameter.savingParameter.minAmount" #minAmount="ngModel" [min]="1" [max]="1000000"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57" id="minAmount" required>

                <mat-error *ngIf="minAmount.invalid && minAmount?.errors.required">Cantidad Mínima de Inscripción es Requerida.
                </mat-error>
                <mat-error *ngIf="minAmount?.errors?.min">La cantidad debe de ser mayor a 1.</mat-error>
                <mat-error *ngIf="minAmount?.errors?.max">La cantidad debe de ser menor a 1,000,000 pesos.</mat-error>

            </mat-form-field>

        </div>

        <div class="col-md-3">

            <mat-form-field>

                <input matInput placeholder="Días Para El Cálculo Máximo" type="number" min="0"
                    [(ngModel)]="modParameter.savingParameter.maxDays" #maxDays="ngModel" [min]="1"
                    [max]="100" onkeypress="return event.charCode >= 48 && event.charCode <= 57" required>

                <mat-error *ngIf="maxDays.invalid && maxDays?.errors?.required">La cantidad de días es requerida.</mat-error>
                <mat-error *ngIf="maxDays?.errors?.min">La cantidad de días debe de ser mayor a 1.</mat-error>

            </mat-form-field>
        </div>

        <div class="col-md-3" *ngIf="modParameter.savingParameter.firstDiscount.dateFirstDiscount" >
            <mat-form-field>
                <input matInput [matDatepicker]="firstDiscountPicker" placeholder="Primer descuento:"
                    (dateChange)="addDateFirstDiscount($event)" [value]="modParameter.savingParameter.firstDiscount.dateFirstDiscount"
                    [disabled]="!modParameter.savingParameter.firstDiscount.dateFirstDiscount">
                <mat-datepicker-toggle matSuffix [for]="firstDiscountPicker"></mat-datepicker-toggle>
                <mat-datepicker #firstDiscountPicker [disabled]="!modParameter.savingParameter.firstDiscount.dateFirstDiscount"></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="col-md-2 m-4" >
            <span> Número de Semana :  </span>
            <span><b>{{modParameter.savingParameter.firstDiscount.weekNumber}}</b></span>
        </div>
    </div>

    <div class="row">

        <div class="col-md-12">

            <div class="file-upload p-3 border">

                <label>
                    <div class="icon my-5">
                        <i class="material-icons">file_upload</i>
                    </div>
                    <input type="file" (change)="detectFiles($event, 'fileSura')" multiple>
                </label>

                <h6 class="my-5 text-center">
                    Instrucciones para Contratar:

                    <a *ngIf="modParameter.savingParameter.fileUploaded.downloadURL; else noURL"
                        href="{{modParameter.savingParameter.fileUploaded.downloadURL}}" target="_blank">
                        {{modParameter.savingParameter.fileUploaded.name}}
                    </a>

                    <ng-template #noURL>

                        <span *ngIf="modParameter.savingParameter.fileUploaded.name; else noFileSelected">
                            {{modParameter.savingParameter.fileUploaded.name}}
                        </span>

                        <ng-template #noFileSelected>
                            <span>
                                No se ha seleccionado ningún archivo
                            </span>
                        </ng-template>

                    </ng-template>

                </h6>

            </div>

        </div>

    </div>

</div>

<div class="p-3" *ngIf="contentLocation.savingParametersIndex == 1">

    <div class="mt-5 row">

        <div class="col-md-4">
            <mat-form-field>
                <input matInput [matDatepicker]="inicioDeCicloPicker" placeholder="Inicio:"
                    (dateChange)="setRegistrationDate('starts', $event)" [value]="newRegistrationDate.startDate">
                <mat-datepicker-toggle matSuffix [for]="inicioDeCicloPicker"></mat-datepicker-toggle>
                <mat-datepicker #inicioDeCicloPicker></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="col-md-4">
            <mat-form-field>
                <input matInput [matDatepicker]="finDeCicloPicker" placeholder="Fin:"
                    (dateChange)="setRegistrationDate('ends', $event)" [value]="newRegistrationDate.endDate"
                    [min]="newRegistrationDate.startDate" [disabled]="!newRegistrationDate.startDate">
                <mat-datepicker-toggle matSuffix [for]="finDeCicloPicker"></mat-datepicker-toggle>
                <mat-datepicker #finDeCicloPicker [disabled]="!newRegistrationDate.startDate"></mat-datepicker>
            </mat-form-field>
        </div>

    </div>


    <div class="row">
        <div class="col-md-4 offset-md-8 center-vertically">
            <button class="btn-block" mat-raised-button color="primary" (click)="addRegistrationDate()">Añadir
                Fechas</button>
        </div>
    </div>

    <div class="my-5 row border-top" *ngIf="modParameter.savingParameter.registrationDates.length > 0">
        <div class="col-md-12">

            <mat-table #registrationDatesTable class="table"
                [dataSource]="modParameter.savingParameter.registrationDates">

                <ng-container matColumnDef="Inicio">
                    <mat-header-cell *matHeaderCellDef> Inicio </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.startDate | date: 'mediumDate'}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Fin">
                    <mat-header-cell *matHeaderCellDef> Fin </mat-header-cell>
                    <mat-cell *matCellDef="let element">{{element.endDate | date: 'mediumDate'}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="active">
                    <mat-header-cell *matHeaderCellDef> Fecha Activa </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <mat-checkbox [(ngModel)]="element.active" [disabled]="false">Fecha Activa</mat-checkbox>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="delete" class="center-text">
                    <mat-header-cell *matHeaderCellDef><span>Eliminar</span></mat-header-cell>
                    <mat-cell *matCellDef="let index = index">
                        <button mat-icon-button color="warn" (click)="deleteRegistrationDate(index)">
                            <mat-icon aria-label="Delete">delete_outline</mat-icon>
                        </button>

                    </mat-cell>
                </ng-container>

                <mat-header-row mat-header-row *matHeaderRowDef="displayedRegistrationDatesColumns"></mat-header-row>
                <mat-row mat-row *matRowDef="let row; columns: displayedRegistrationDatesColumns;"></mat-row>

            </mat-table>

        </div>
    </div>

</div>

<div class="p-3" *ngIf="contentLocation.savingParametersIndex == 2">

    <div class="row">

        <div class="col-md-12">

            <mat-table #companiesTable class="table"
                [dataSource]="logicService.dataManager.generalDataLoader.companies">


                <ng-container matColumnDef="companyID">
                    <mat-header-cell mat-header-cell *matHeaderCellDef> ID </mat-header-cell>
                    <mat-cell mat-cell *matCellDef="let element"> {{element.companyID}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="companyName">
                    <mat-header-cell mat-header-cell *matHeaderCellDef> Nombre de la Compañía </mat-header-cell>
                    <mat-cell mat-cell *matCellDef="let element"> {{element.companyName}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="taxationIdentificationNumber">
                    <mat-header-cell mat-header-cell *matHeaderCellDef> Documento Legal </mat-header-cell>
                    <mat-cell mat-cell *matCellDef="let element"> {{element.taxationIdentificationNumber}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="select">
                    <mat-header-cell mat-header-cell *matHeaderCellDef>
                        Incluir Compañía
                    </mat-header-cell>
                    <mat-cell mat-cell *matCellDef="let row">
                        <mat-checkbox (click)="$event.stopPropagation()"
                            (change)="$event ? selectionCompanies.toggle(row) : null"
                            [checked]="selectionCompanies.isSelected(row)"></mat-checkbox>
                    </mat-cell>
                </ng-container>

                <mat-header-row mat-header-row *matHeaderRowDef="displayedCompanyColumns"></mat-header-row>
                <mat-row mat-row *matRowDef="let row; columns: displayedCompanyColumns;"></mat-row>
            </mat-table>

        </div>

    </div>

</div>

<div class="p-3" *ngIf="contentLocation.savingParametersIndex == 3">

    <div class="row">

        <div class="col-md-12">

            <mat-table #departmentTable class="table"
                [dataSource]="logicService.dataManager.generalDataLoader.contracts">

                <ng-container matColumnDef="contractID">
                    <mat-header-cell mat-header-cell *matHeaderCellDef> ID Contrato </mat-header-cell>
                    <mat-cell mat-cell *matCellDef="let element"> {{element.contractID}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="description">
                    <mat-header-cell mat-header-cell *matHeaderCellDef> Tipo Contrato </mat-header-cell>
                    <mat-cell mat-cell *matCellDef="let element"> {{element.description}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="select">
                    <mat-header-cell mat-header-cell *matHeaderCellDef>
                        Incluir Contrato
                    </mat-header-cell>
                    <mat-cell mat-cell *matCellDef="let row">
                        <mat-checkbox (click)="$event.stopPropagation()"
                            (change)="$event ? selectionContracts.toggle(row) : null"
                            [checked]="selectionContracts.isSelected(row)"></mat-checkbox>
                    </mat-cell>
                </ng-container>

                <mat-header-row mat-header-row *matHeaderRowDef="displayedContractColumns"></mat-header-row>
                <mat-row mat-row *matRowDef="let row; columns: displayedContractColumns;"></mat-row>

            </mat-table>

        </div>

    </div>

</div>